const UseDebugValue = () => {
    return (
        <div className="demo-container">
            <div className="demo-box">
                <code>Used to add labels to custom hooks for labelling in React DevTools.<br/><br/> Check more at : https://beta.reactjs.org/reference/react/useDebugValue</code>
            </div>
        </div>
    )
}

export default UseDebugValue